import React, { useEffect, useState } from 'react'
import { Text } from '@/style-guide'
import { Card } from './Card'
import { PaymentCard, Loader } from '@/components'
import { PaymentCardList, ModalConfirm } from '@/components'
import {
  APIS,
  listCards,
  updateBooking,
  updateCurrentUser,
} from '@/utils/apiEndpoints'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import { fetchUser } from '@/store/actions'
import { CryptoPaymentDetails } from '../Crypto/CryptoPaymentDetails'
import { useCryptoPay } from '@/hooks/crypto/useCrypto'
import { getCosting } from '@/utils/InvoiceHelper'
import { CryptoPaymentModal } from '@/components/Crypto/CryptoPaymentModal'
import { clearState } from '@/store/crypto-wallet'

const DAY = 86400 //seconds

// Depricated
export const PaymentMethod = ({ booking, trip, getBooking }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { currentUser } = useSelector((state) => state.auth)
  //we may be using crypto payments so grab that redux state
  const {
    status: walletStatus,
    error: walletError,
    paymentDetails: cryptoPaymentDetails,
  } = useSelector((state) => state.cryptoWallet)

  const { stripePaymentMethod, cryptoPaymentMethod, paymentMethodType } =
    booking || {}
  const { tripPaymentType } = booking || {}
  const [isOpen, setIsOpen] = useState(false)

  //use the crypto hook info to prompt and move the user through crypto payment flow
  const {
    startPayment,
    nextStep,
    cancel,
    allowedNetworks,
    allowedTokens,
    selectedNetwork,
  } = useCryptoPay(trip)

  //for crypto adjustment
  const { paynowAmount } = getCosting(booking, trip)

  const onSelectCard = async (cardInfo) => {
    try {
      setLoading(true)
      await updateBooking(booking._id, {
        stripePaymentMethod: cardInfo,
        paymentMethod: cardInfo.id,
      })
      getBooking && getBooking(booking._id)
      setIsOpen(false)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  const onCryptoUpdate = async (crypto) => {
    try {
      setLoading(true)
      await updateBooking(booking._id, {
        cryptoPaymentMethod: crypto,
      })
      dispatch(clearState())
      getBooking && getBooking(booking._id)
    } catch (e) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (cryptoPaymentDetails) {
      onCryptoUpdate(cryptoPaymentDetails)
    }
  }, [cryptoPaymentDetails])

  const formItems = () => {
    return (
      <PaymentCardList
        stripePaymentMethod={stripePaymentMethod}
        onSelectCard={onSelectCard}
        showBorder={true}
        onCancel={() => setIsOpen(false)}
      />
    )
  }
  return (
    <div>
      {tripPaymentType == 'pay' &&
        stripePaymentMethod &&
        paymentMethodType == 'cards' && (
          <div style={{ paddingTop: '10px' }}>
            <Text>Saved payment method</Text>
            <Card card={stripePaymentMethod} />
            {booking && currentUser && booking.memberId == currentUser._id && (
              <Button type="link" onClick={() => setIsOpen(true)}>
                Change payment method
              </Button>
            )}
          </div>
        )}
      {tripPaymentType == 'pay' &&
        cryptoPaymentMethod &&
        paymentMethodType == 'crypto' && (
          <div style={{ paddingTop: '10px' }}>
            <Text>Crypto Payment Details</Text>
            <CryptoPaymentDetails booking={booking} />
            {booking && currentUser && booking.memberId == currentUser._id && (
              <Button
                type="link"
                onClick={() =>
                  startPayment(
                    paynowAmount,
                    Math.ceil(Date.now() / 1000) +
                    trip.bookingExpiryDays * DAY +
                    DAY,
                  )
                }
              >
                Change payment
              </Button>
            )}
          </div>
        )}

      <CryptoPaymentModal
        onCancel={cancel}
        onNext={nextStep}
        payState={walletStatus}
        allowedNetworks={allowedNetworks}
        allowedTokens={allowedTokens}
      />

      <ModalConfirm
        visible={isOpen}
        loading={loading}
        isForm={false}
        formItems={formItems}
        footer={[]}
        onCancel={() => setIsOpen(false)}
      />
    </div>
  )
}

export const PrimaryPaymentMethod = ({ organization, loadOrganization }) => {
  const dispatch = useDispatch()
  const { currentUser } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const [cardList, setCardList] = useState([])
  const [cardInfo, setCardInfo] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const onSelectCard = async (cardInfo) => {
    try {
      setLoading(true)
      await APIS.updateOrganization(organization._id, {
        paymentMethod: cardInfo.id,
        stripeCustomerId: currentUser?.stripeCustomerId,
      })
      loadOrganization()
      setIsOpen(false)
      setCardInfo(cardInfo)
      dispatch(fetchUser())
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  const loadCards = async () => {
    try {
      setLoading(true)
      if (organization.stripeCustomerId || currentUser?.stripeCustomerId) {
        const res = await listCards(
          organization.stripeCustomerId || currentUser?.stripeCustomerId,
        )
        setCardList(res.result)
        setCardInfo(res.result?.find((c) => c.id == organization.paymentMethod))
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  const formItems = () => {
    return (
      <PaymentCardList
        stripePaymentMethod={cardInfo}
        onSelectCard={onSelectCard}
        showBorder={true}
        onCancel={() => setIsOpen(false)}
        cards={cardList}
        isUser={false}
      />
    )
  }
  useEffect(() => {
    loadCards()
  }, [])
  if (loading) return <Loader loading={true} />;
  return (
    <div>
      {cardInfo?.id ? (
        <div>
          <Text>This payment method will get automatically charged</Text>
          <PaymentCard card={cardInfo} />
          <Button
            block
            type="ghost"
            size="large"
            onClick={() => setIsOpen(true)}
            style={{ marginTop: '15px' }}
          >
            Change payment method
          </Button>
        </div>
      ) : (
        <Button
          block
          type="ghost"
          size="large"
          onClick={() => setIsOpen(true)}
          style={{ marginTop: '15px' }}
        >
          Add payment method
        </Button>
      )}
      <ModalConfirm
        title="Payment method"
        visible={isOpen}
        loading={loading}
        isForm={false}
        formItems={formItems}
        footer={null}
        onCancel={() => setIsOpen(false)}
      />
    </div>
  )
}
